export enum Language {
  EN = 'en',
  RO = 'ro',
}
